import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

/*  This text is reused a lot of time in the catalog
 */
type Props = {
    engagedActions: number;
    totalActions: number;
};
export const EngagedActTypo = (props: Props) => {
    const { t } = useTranslation();

    const { engagedActions, totalActions } = props;
    return (
        <Typography variant="body-medium">
            {t("action_plan.engaged_action_stats", "Engaged Actions: {{engagedActions}} / {{totalActions}}", {
                engagedActions: engagedActions,
                totalActions: totalActions,
            })}
        </Typography>
    );
};
